import Head from "next/head";
import {generateTitle} from "../../helpers/meta";
import {useRouter} from "next/router";
import localized from "../../locale/locales";
import Embed from "../../components/Embed";

function getForm(locale) {
    return 'https://r54y2u3ick3.typeform.com/to/pnWYNAat';

    // switch (locale) {
    //     case 'cs':
    //         return 'https://r54y2u3ick3.typeform.com/to/BKhdBYUH';
    //     case 'es':
    //         return 'https://r54y2u3ick3.typeform.com/to/g08oxa5D';
    //     case 'en':
    //     default:
    //         return 'https://r54y2u3ick3.typeform.com/to/q5E3CQgi';
    // }
}

export default function JustEatRegister() {
    const {locale} = useRouter();
    const {register: lang} = localized[locale];

    return (
        <>
            <Head>
                <title key="title">{generateTitle(lang.og.title)}</title>
                <meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>
            </Head>

            <Embed url={getForm(locale)}/>
        </>
    )
}
